import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import './ConciergeView.scss'
import ScheduleAppointmentView from './ScheduleAppointmentView'

const MAIN = 'MAIN'
const SCHEDULE_APPOINTMENT = 'SCHEDULE_APPOINTMENT'

const TABS = {
  MAIN,
  SCHEDULE_APPOINTMENT
}

class ConciergeView extends React.Component {
  static defaultProps = {
    getPatients: _.noop,
    getSites: _.noop,
    createAppointment: _.noop,
    getNearbyAppointments: _.noop,
    getUsers: _.noop,
  }

  static propTypes = {
    getSites: PropTypes.func,
    sites: PropTypes.array,
    getPatients: PropTypes.func,
    patients: PropTypes.object,
    ui: PropTypes.shape({
      isFetchingPatients: PropTypes.bool,
      isFetchingSites: PropTypes.bool
    }),
    createAppointment: PropTypes.func,
    getNearbyAppointments: PropTypes.func,
    getUsers: PropTypes.func,
    users: PropTypes.array,
  }

  constructor (props) {
    super(props)
    this.state = {
      activeTab: MAIN,
      selectedSiteId: null,
      selectedPatientId: null
    }
  }

  componentDidMount () {
    this.props.getSites()
    this.props.getUsers('CONCIERGE_OPERATOR')

    if (this.props.location.hash){
      var loc = this.props.location.hash.substr(1).split('&')
      this.setState({ activeTab:  loc[0] })

      if (loc.length > 1) {
        this.setState({
          selectedSiteId: parseInt(loc[1]),
          selectedPatientId: parseInt(loc[2])
        })
      }
    }
  }

  setActiveTab = (activeTab) => {
    this.setState({ activeTab })
  }

  render () {
    var { activeTab } = this.state

    return (
      <div>
        <div>
          <ul className='nav nav-tabs'>
            <li className='nav-item'>
              <div
                className={`nav-link ${activeTab === TABS[MAIN] ? 'active' : ''}`}
                onClick={() => this.setActiveTab(TABS[MAIN])}>
                Home
              </div>
            </li>
            <li className='nav-item'>
              <div
                className={`nav-link ${activeTab === TABS[SCHEDULE_APPOINTMENT] ? 'active' : ''}`}
                onClick={() => this.setActiveTab(TABS[SCHEDULE_APPOINTMENT])}>
                Schedule Appointment
              </div>
            </li>
          </ul>
        </div>
        {
          activeTab === TABS[MAIN]
          ? <div>Hi</div>
          : null
        }
        {
          activeTab === TABS[SCHEDULE_APPOINTMENT]
          ? (
            <ScheduleAppointmentView
              getSites={this.props.getSites}
              sites={this.props.sites}
              isFetchingSites={this.props.ui.isFetchingSites}
              getPatients={this.props.getPatients}
              patients={this.props.patients}
              isFetchingPatients={this.props.ui.isFetchingPatients}
              createAppointment={this.props.createAppointment}
              getNearbyAppointments={this.props.getNearbyAppointments}
              selectedSiteId={this.state.selectedSiteId}
              selectedPatientId={this.state.selectedPatientId}
              getUsers={this.props.getUsers}
              users={this.props.users}
              isFetchingUsers={this.props.ui.isFetchingUsers}
            />
          ) : null
        }
      </div>
    )
  }
}

export default ConciergeView



// WEBPACK FOOTER //
// ./src/routes/Concierge/components/ConciergeView.jsx